import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-6" }
const _hoisted_2 = { class: "grid grid-cols-2 gap-4" }
const _hoisted_3 = { class: "border rounded-2xl border-black shadow-lg filter px-3 py-1.5" }
const _hoisted_4 = { class: "flex p-1.5" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "dark:text-white" }
const _hoisted_7 = {
  key: 0,
  class: "italic text-sm text-blue-secondary"
}
const _hoisted_8 = {
  key: 1,
  class: "text-sm text-gray-600 dark:text-yellow-primary"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("button", null, "Order", -1)

import { onMounted, ref, watch } from 'vue';

// Define custom table names

export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const tableNames = [
  '001', '002', '003', '004', '005', '006', '007',
  '01', '02','1', '2', '3', '4', '5', '6', '7', '8', '9', '10',
  '6A', '6B', '8A', '8B', '10A', '10B'
];

const totalTable = tableNames.length; // Set totalTable based on tableNames length
const tables = ref<boolean[]>([]);

// Initialize tables array
for (let i = 0; i < totalTable; i++) {
  tables.value.push(false);
}

const toggleServe = (index: number) => {
  tables.value[index] = !tables.value[index];
};

const updateTableStorage = () => {
  localStorage.setItem('tables', JSON.stringify(tables.value));
};

//patch 1 data, do not remove this
if(localStorage.getItem('table')){
  localStorage.removeItem("table")
}
// Load table data from localStorage if available
if (localStorage.getItem('tables') != null) {
  tables.value = JSON.parse(localStorage.getItem('tables') ?? '');
}

// Ensure localStorage is updated on mount
onMounted(() => {
  updateTableStorage();
});

// Watch for changes in tables array and update localStorage
watch(
  () => tables.value,
  () => {
    updateTableStorage();
  },
  { deep: true }
);

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tables.value, (table, index) => {
        return (_openBlock(), _createElementBlock("div", { key: index }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", {
                class: "cursor-pointer",
                onClick: ($event: any) => (toggleServe(index))
              }, [
                _createElementVNode("div", _hoisted_6, "Table " + _toDisplayString(tableNames[index]), 1),
                table
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, "Currently Serving"))
                  : (_openBlock(), _createElementBlock("div", _hoisted_8, "Ready to serve"))
              ], 8, _hoisted_5),
              table
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    class: "text-blue-secondary ml-auto my-auto",
                    to: { name: 'Orders', params: { index: tableNames[index] } }
                  }, {
                    default: _withCtx(() => [
                      _hoisted_9
                    ]),
                    _: 2
                  }, 1032, ["to"]))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      }), 128))
    ])
  ]))
}
}

})